import { supabase } from '@/lib/supabase'

export type ObjectiveIcons = { bull: string; bear: string }

const KEY_BULL = 'ui.icon.bull_url'
const KEY_BEAR = 'ui.icon.bear_url'

// Fallbacks (serão usados apenas se não houver configuração no banco)
const DEFAULTS: ObjectiveIcons = {
  bull: 'https://emoji.slack-edge.com/T01CVT1T6D7/bull/8ff93a00b2e49716.png',
  bear: 'https://emoji.slack-edge.com/T01CVT1T6D7/bear2/d1655c7f975efede.png',
}

let cached: ObjectiveIcons | null = null
let inflight: Promise<ObjectiveIcons> | null = null

export async function getObjectiveIcons(): Promise<ObjectiveIcons> {
  if (cached) return cached
  if (inflight) return inflight
  inflight = (async () => {
    try {
      const { data, error } = await supabase
        .from('app_settings')
        .select('key,value')
        .in('key', [KEY_BULL, KEY_BEAR])
      if (error) return DEFAULTS
      const map = new Map<string, string>((data || []).map((r: any) => [String(r.key), String(r.value)]))
      const bull = map.get(KEY_BULL) || DEFAULTS.bull
      const bear = map.get(KEY_BEAR) || DEFAULTS.bear
      cached = { bull, bear }
      return cached
    } catch {
      return DEFAULTS
    } finally {
      inflight = null
    }
  })()
  return inflight
}

